import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=a39f331a&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Profile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Profile.vue?vue&type=style&index=0&id=a39f331a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39f331a",
  null
  
)

export default component.exports